import api from "./api";

const route = "/courses";

export default {
  getCourses: () => api.get(route),
  getSingleCourse: (course_id) => api.get(`${route}/${course_id}`),
};
